/* akuma-rsl.js - shared script for Akuma RSL sections.
   Idempotent - safe to load from multiple sections on the same page. */
(function(){
  if (window.__akuma_rsl_init) return;
  window.__akuma_rsl_init = true;

  // ----- Scroll-triggered reveals -----
  function observeReveals(root){
    var nodes = (root||document).querySelectorAll('.akuma-rsl .reveal:not([data-akr-seen])');
    nodes.forEach(function(el){ el.dataset.akrSeen='1'; io.observe(el); });
  }
  var io;
  if ('IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    observeReveals();
    if ('MutationObserver' in window){
      new MutationObserver(function(){ observeReveals(); })
        .observe(document.body, { childList:true, subtree:true });
    }
  } else {
    document.querySelectorAll('.akuma-rsl .reveal').forEach(function(el){ el.classList.add('in'); });
  }

  // ----- Hero parallax (any element with data-akr-parallax) -----
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var ticking = false;
    function update(){
      var y = window.scrollY;
      document.querySelectorAll('[data-akr-parallax]').forEach(function(el){
        el.style.transform = 'translate3d(0,' + (y*0.25) + 'px,0) scale(' + (1 + y*0.0002) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  // ----- Buy box quantity fix -----
  // The theme's global input padding clips the digit in the narrow qty field.
  // Force zero padding + an adequate width via inline styles (highest priority).
  function akumaFixQty(){
    document.querySelectorAll('.akuma-buybox .qty-stepper input').forEach(function(q){
      q.style.setProperty('padding','0','important');
      q.style.setProperty('padding-inline','0','important');
      q.style.setProperty('width','48px','important');
      q.style.setProperty('text-indent','0','important');
      q.style.setProperty('text-align','center','important');
      if(!q.value){ q.value = '1'; }
    });
  }
  if (document.readyState !== 'loading'){ akumaFixQty(); }
  else { document.addEventListener('DOMContentLoaded', akumaFixQty); }
  setTimeout(akumaFixQty, 400);
    // ----- Buy box variant pill sync -----
  document.addEventListener('click', function(e){
    var pill = e.target.closest('.akuma-buybox .variant-pill');
    if (!pill) return;
    var container = pill.closest('.akuma-buybox');
    if (!container) return;
    var formEl = container.querySelector('[id^="akuma-buy-form-"]');
    var formId = formEl ? formEl.id.replace('akuma-buy-form-','') : null;
    if (!formId) return;

    var optionPills = pill.closest('.variant-pills');
    optionPills.querySelectorAll('.variant-pill').forEach(function(p){ p.setAttribute('aria-pressed','false'); });
    pill.setAttribute('aria-pressed','true');
    var display = container.querySelector('[data-option-display="'+optionPills.dataset.optionIndex+'"]');
    if (display) display.textContent = pill.dataset.value;

    var selectedOptions = [];
    container.querySelectorAll('.variant-pills').forEach(function(group){
      var active = group.querySelector('.variant-pill[aria-pressed="true"]');
      selectedOptions.push(active ? active.dataset.value : null);
    });

    var productDataEl = container.querySelector('[data-product-json]');
    if (!productDataEl) return;
    var productData = JSON.parse(productDataEl.textContent);
    var matched = null;
    productData.variants.forEach(function(v){
      if (matched) return;
      var opts = [v.option1, v.option2, v.option3];
      if (selectedOptions.every(function(val,i){ return val===null||opts[i]===val; })) matched = v;
    });
    if (!matched) return;

    var select = document.getElementById('akuma-vid-'+formId);
    if (select){ select.value = matched.id; select.dispatchEvent(new Event('change',{bubbles:true})); }

    function fmt(cents){ return '$'+(cents/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','); }
    var priceEl = container.querySelector('.buy-price:not(.compare)');
    var compareEl = container.querySelector('.buy-price.compare');
    if (priceEl) priceEl.textContent = fmt(matched.price);
    var addPriceEl = document.getElementById('akuma-add-price-'+formId);
    if (addPriceEl) addPriceEl.textContent = fmt(matched.price);
    var stickyPriceEl = document.getElementById('akuma-sticky-price-'+formId);
    if (stickyPriceEl) stickyPriceEl.textContent = fmt(matched.price);
    if (compareEl){ compareEl.style.display = matched.compare_at_price > matched.price ? '' : 'none'; if(matched.compare_at_price>matched.price) compareEl.textContent=fmt(matched.compare_at_price); }

    var stockEl = document.getElementById('akuma-stock-'+formId);
    if (stockEl){ stockEl.textContent = matched.available?'In Stock':'Sold Out'; stockEl.classList.toggle('out',!matched.available); }

    var addBtn = document.getElementById('akuma-add-'+formId);
    if (addBtn){
      addBtn.disabled = !matched.available;
      addBtn.childNodes[0].textContent = matched.available?'Add to Cart':'Sold Out';
      var priceSpan = addBtn.querySelector('.price-on-cta');
      if (priceSpan) priceSpan.textContent = fmt(matched.price);
    }

    var stickyVar = document.getElementById('akuma-sticky-var-'+formId);
    if (stickyVar) stickyVar.textContent = matched.title;

    var mainImgEl = container.querySelector('[id^="akuma-main-img-"]');
    if (mainImgEl && matched.featured_image) mainImgEl.src = matched.featured_image.src;
  });

})();
